// DashboardMuiEcharts.jsx
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  TableContainer,
  Tooltip,
  LinearProgress,
  ToggleButtonGroup,
  ToggleButton,
  TextField,
  MenuItem,
  TablePagination,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import Navbar1 from "../Navbar/Navbar1";
import ReactECharts from "echarts-for-react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "axios";

const cellStyle = {
  fontFamily: "Poppins, sans-serif",
  fontSize: "14px",
  color: "#000",
  whiteSpace: "nowrap",
  paddingTop: "10px",
  paddingBottom: "10px",
};

const smallTextFieldSx = {
  width: 160,

  "& .MuiInputBase-root": {
    height: 25,
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
  },

  "& .MuiInputBase-input": {
    padding: "6px 10px",
    fontFamily: "Poppins, sans-serif",
  },

  // "& .MuiOutlinedInput-notchedOutline": {
  //   borderRadius: "8px",
  // },
};

export default function ConsuptionDashboard() {
  const machineMacInfo =
    JSON.parse(localStorage.getItem("machineMacInfo")) || [];

  const [mac_id, setMac_id] = useState(machineMacInfo[0]?.mac_id);

  const [alignment, setAlignment] = React.useState("day");
  const [selectDate, setSeletDate] = useState(dayjs());

  const [selectionDate, setSelectionDae] = useState(dayjs());
  const [startDate, setStartDate] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    dayjs().endOf("month").format("YYYY-MM-DD"),
  );

  const [loading, setLoading] = useState(false);
  const [selectCat, setSelectCat] = useState("Aggregate");
  const [consuptionDataTable, setConsuptionDataTable] = useState([]);
  const [consuptionChartData, setConsuptionChartData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [selectBar, setSelectBar] = useState("Batch Count");
  const [selectBarList, setSelectBarList] = useState([
    "Batch Count",
    "Calculate Production Quantity",
    "Rated Batch",
    "Under Rated Batch",
  ]);

  const [selectName, setSelectName] = useState(null);

  const [noData, setNoData] = useState(false);
  const [allNames, setAllNames] = useState(null);

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);

    if (newAlignment === "day") {
      setStartDate(dayjs().startOf("month").format("YYYY-MM-DD"));
      setEndDate(dayjs().endOf("month").format("YYYY-MM-DD"));
      setSelectionDae(dayjs());
    } else if (newAlignment === "month") {
      setStartDate(dayjs().startOf("year").format("YYYY-MM-DD"));
      setEndDate(dayjs().endOf("year").format("YYYY-MM-DD"));
      setSelectionDae(dayjs());
    }
  };

  const categoryIndex =
    selectCat === "Aggregate"
      ? 0
      : selectCat === "Cement"
        ? 1
        : selectCat === "Water"
          ? 2
          : selectCat === "Admixture"
            ? 3
            : 0;

  const option = {
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} ({d}%)",
    },
    legend: {
      orient: "horizontal", // horizontal for bottom
      itemGap: 30,
      bottom: "0", // distance from bottom
      left: "center", // center horizontally
      data: ["Within Tolerance", "Out of Tolerance"],
      textStyle: {
        fontFamily: "Poppins, sans-serif",
        fontSize: 14,
      },
    },

    series: [
      {
        name: "Tolerance Status",
        type: "pie",
        radius: ["40%", "70%"], // donut shape
        center: ["50%", "45%"],
        avoidLabelOverlap: false,
        label: {
          //   show: true,
          position: "inside",
          fontFamily: "Poppins, sans-serif",
          fontSize: 16,
          fontWeight: "bold",
          color: "#fff",
          formatter: "{c}", // shows the value inside the slice
        },
        labelLine: {
          show: false,
        },
        data: [
          {
            value: consuptionDataTable[categoryIndex]?.data?.find(
              (m) => m.name === selectName,
            )?.wit,
            name: "Within Tolerance",
            itemStyle: { color: "#3385ff" },
          },
          {
            value: consuptionDataTable[categoryIndex]?.data?.find(
              (m) => m.name === selectName,
            )?.wot,
            name: "Out of Tolerance",
            itemStyle: { color: "#ff3333" },
          },
        ],
      },
    ],
  };

  // --------- Bar Chart (Monthly Order Completion Rate) -----------

  const appConfig = {
    position: "top",
    distance: 9,
    align: "middle",
    verticalAlign: "middle",
  };

  const labelOption = {
    show: true,
    position: appConfig.position,
    distance: appConfig.distance,
    align: appConfig.align,
    verticalAlign: appConfig.verticalAlign,
    rotate: appConfig.rotate,

    // fontSize: 16,

    fontSize: 10,
    color: "#2e2e2e",
    fontFamily: "Poppins, sans-serif",
    // fontWeight: "bold",

    rich: {
      name: {},
    },
  };

  const barOption = {
    backgroundColor: "#ffffff",

    tooltip: {
      trigger: "axis", // hover on bar
      axisPointer: {
        type: "shadow",
      },
      formatter: (params) => {
        const data = params[0];
        return `
        <b>${data.axisValue}</b><br/>
        Production: ${data.value}
      `;
      },
    },

    grid: { left: 40, right: 20, top: 20, bottom: 0 },

    textStyle: {
      fontFamily: "Poppins, sans-serif", // ALL TEXT USE POPPINS
    },

    xAxis: {
      type: "category",
      data:
        alignment == "day"
          ? consuptionChartData.map((item) =>
              dayjs(item.period).format("DD-MMM"),
            )
          : consuptionChartData.map((item) => item.period),
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        fontFamily: "Poppins, sans-serif",
      },
    },
    yAxis: {
      type: "value",
      name: "Production",
      nameLocation: "middle",
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: {
        fontFamily: "Poppins, sans-serif",
      },
    },
    series: [
      {
        type: "bar",
        barWidth: "60%",
        label: labelOption,
        data: consuptionChartData.map((item) => ({
          value:
            selectBar == "Batch Count"
              ? +Number(item.cnt || 0).toFixed(2)
              : selectBar == "Calculate Production Quantity"
                ? +Number(item.cp_qty || 0).toFixed(2)
                : selectBar == "Rated Batch"
                  ? +Number(item.rate || 0).toFixed(2)
                  : selectBar == "Under Rated Batch"
                    ? +Number(item.unrate || 0).toFixed(2)
                    : "",
          itemStyle: {
            color: "#6694ff",
            borderRadius: [2, 2, 0, 0],
          },
        })),
      },
    ],
  };

  const chartApi = () => {
    const payload =
      // date: dayjs(selectDate).format("MM"),
      {
        rpt_type: alignment, //”day”/”month”/”year”
        mac_id: mac_id,
        start:
          alignment == "day"
            ? startDate
            : alignment == "month"
              ? startDate
              : "2023-01-01",
        end:
          alignment == "day"
            ? endDate
            : alignment == "month"
              ? endDate
              : dayjs().format("YYYY-MM-DD"),
      };

    const token = localStorage.getItem("token");

    axios
      .post(
        `https://iot-api.elantristechnologies.com/api/BatchingPlant/Dashboard_ProductionData`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ headers here
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        if (res.data.status == 1) {
          console.log(res.data);

          setConsuptionChartData(res.data.data);

          setLoading(false);
          setNoData(false);
        } else {
          setNoData(true);
        }
      })
      .catch((err) => {
        alert(err);
        setLoading(false);
      });
  };

  const ConsuptionApi = () => {
    const payload =
      // date: dayjs(selectDate).format("MM"),
      {
        rpt_type: alignment, //”day”/”month”/”year”
        mac_id: mac_id,
        start:
          alignment == "day"
            ? startDate
            : alignment == "month"
              ? startDate
              : "2023-01-01",
        end:
          alignment == "day"
            ? endDate
            : alignment == "month"
              ? endDate
              : dayjs().format("YYYY-MM-DD"),
      };

    const token = localStorage.getItem("token");

    axios
      .post(
        `https://iot-api.elantristechnologies.com/api/BatchingPlant/Dashboard_ConsumptionData`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ headers here
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        if (res.data.status == 1) {
          console.log(res.data);

          setConsuptionDataTable(res.data.data);

          const names =
            res.data.data?.[
              selectCat === "Aggregate"
                ? 0
                : selectCat === "Cement"
                  ? 1
                  : selectCat === "Water"
                    ? 2
                    : selectCat === "Admixture"
                      ? 3
                      : 0
            ]?.data?.map((item) => item.name) || [];

          setAllNames(names);

          setNoData(false);
          setLoading(false);
        } else {
          setNoData(true);
        }
      })
      .catch((err) => {
        alert(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (machineMacInfo.length > 0) {
      const first = machineMacInfo[0];

      setMac_id(first.mac_id);
    }
  }, []);

  useEffect(() => {
    if (mac_id != null) {
      chartApi();
      ConsuptionApi();
    }
  }, [startDate, alignment, selectionDate]);

  const category = [
    { label: "Aggregate", value: "Aggregate" },
    { label: "Cement", value: "Cement" },
    { label: "Water", value: "Water" },
    { label: "Admixture", value: "Admixture" },
  ];

  useEffect(() => {
    const names =
      consuptionDataTable?.[
        selectCat === "Aggregate"
          ? 0
          : selectCat === "Cement"
            ? 1
            : selectCat === "Water"
              ? 2
              : selectCat === "Admixture"
                ? 3
                : 0
      ]?.data?.map((item) => item.name) || [];

    setAllNames(names);
  }, [selectCat]);

  useEffect(() => {
    if (allNames?.length > 0) {
      const firstWord = allNames[0].split(" ")[0];

      setSelectName(firstWord);
    }
  }, [allNames]);

  //Table Data

  // Extract the material data
  const materialArr = useMemo(() => {
    const category = consuptionDataTable?.find((c) => c.cat === selectCat);
    const material = category?.data?.find((m) => m.name === selectName);
    return material?.arr || [];
  }, [consuptionDataTable, selectCat, selectName]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <Navbar1>
        <Grid sx={{ display: "flex", justifyContent: "right", gap: 2 }}>
          <Box>
            <Typography
              sx={{
                color: "#333",
                fontFamily: "Poppins, sans-serif",
                fontSize: "13px",
              }}
            >
              Select Mixing Materials
            </Typography>
            <TextField
              select
              size='small'
              value={selectCat}
              onChange={(e) => setSelectCat(e.target.value)}
              sx={smallTextFieldSx}
            >
              {category.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box>
            <Typography
              sx={{
                color: "#333",
                fontFamily: "Poppins, sans-serif",
                fontSize: "13px",
              }}
            >
              Select Material Type
            </Typography>
            <TextField
              select
              size='small'
              value={selectName}
              onChange={(e) => setSelectName(e.target.value)}
              sx={smallTextFieldSx}
            >
              {allNames?.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Grid>
            <Typography
              sx={{
                color: "#333",
                fontFamily: "Poppins, sans-serif",
                fontSize: "13px",
              }}
            >
              Choose Time Slot
            </Typography>
            <ToggleButtonGroup
              value={alignment}
              exclusive
              onChange={handleChange}
              aria-label='Platform'
              sx={{
                "& .MuiToggleButton-root": {
                  textTransform: "none",
                  height: 26,
                  fontFamily: "Poppins, sans-serif",
                  // px: 3,
                  // borderRadius: "8px",
                },
                "& .Mui-selected": {
                  backgroundColor: "#0066FF !important",
                  color: "#fff !important",
                },
                "& .Mui-selected:hover": {
                  backgroundColor: "#0066FF",
                },
              }}
            >
              <ToggleButton value='day'>Date</ToggleButton>
              <ToggleButton value='month'>Month</ToggleButton>
              <ToggleButton value='year'>Year</ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Grid sx={{ display: "flex" }}>
                {alignment !== "year" && (
                  <Grid>
                    <Typography
                      sx={{
                        color: "#333",
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "13px",
                      }}
                    >
                      {alignment === "day"
                        ? "Select Month"
                        : alignment === "month"
                          ? "Select Year"
                          : ""}
                    </Typography>

                    <DatePicker
                      views={
                        alignment === "day"
                          ? ["year", "month"]
                          : alignment === "month"
                            ? ["year"]
                            : ["year"]
                      }
                      format={alignment === "day" ? "YYYY-MMM" : "YYYY"}
                      sx={{ width: 150 }}
                      value={selectionDate}
                      onChange={(date) => {
                        setSelectionDae(date);
                        if (alignment == "day") {
                          setStartDate(
                            dayjs(date).startOf("month").format("YYYY-MM-DD"),
                          );
                          setEndDate(
                            dayjs(date).endOf("month").format("YYYY-MM-DD"),
                          );
                        } else if (alignment == "month") {
                          setStartDate(
                            dayjs(date).startOf("year").format("YYYY-MM-DD"),
                          );
                          setEndDate(
                            dayjs(date).endOf("year").format("YYYY-MM-DD"),
                          );
                        }
                      }}
                      slotProps={{
                        textField: {
                          variant: "outlined",
                          InputProps: {
                            sx: {
                              fontFamily: "Times New Roman",
                              fontSize: "0.8rem",
                              height: 25,
                              "& .MuiInputBase-input": {
                                padding: "2px 6px",
                                fontSize: "0.7rem",
                              },
                              "& .MuiSvgIcon-root": {
                                fontSize: "1rem",
                              },
                            },
                          },
                        },
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </LocalizationProvider>
          </Box>
        </Grid>
        {noData == false ? (
          <Grid sx={{ paddingLeft: 3, paddingRight: 3 }}>
            <Grid container spacing={2}>
              <Grid size={{ lg: 4, xs: 12, md: 12, sm: 12 }}>
                <Paper sx={{ padding: 2, boxShadow: "none" }}>
                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 550,
                          fontSize: "18px",
                          mb: 1,
                          fontFamily: "Poppins, sans-serif",
                        }}
                      >
                        Tolerance Compliance {selectCat} - ({selectName})
                      </Typography>
                    </Grid>
                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      {/* <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "14px",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      >
                        {dayjs(startDate).format("DD-MMM-YYYY")} to{" "}
                        {dayjs(endDate).format("DD-MMM-YYYY")}
                      </Typography> */}
                    </Grid>
                  </Grid>

                  <ReactECharts
                    option={option}
                    style={{ height: 230, width: "100%" }}
                  />
                </Paper>
              </Grid>
              <Grid size={{ lg: 8, xs: 12, md: 12, sm: 12 }}>
                <Paper sx={{ padding: 2, boxShadow: "none" }}>
                  <Grid
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Grid>
                      <Typography
                        sx={{
                          fontWeight: 550,
                          fontSize: "18px",
                          mb: 1,
                          fontFamily: "Poppins, sans-serif",
                        }}
                      >
                        {selectBar == "Batch Count"
                          ? "Batch Production Count"
                          : "Calculate Production Quantity"}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{ display: "flex", alignItems: "center", gap: 2 }}
                    >
                      <Grid>
                        {/* <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: "14px",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          {dayjs(selectDate).format("YYYY")}
                        </Typography> */}
                        <TextField
                          select
                          size='small'
                          value={selectBar}
                          onChange={(e) => setSelectBar(e.target.value)}
                          sx={smallTextFieldSx}
                        >
                          {selectBarList?.map((name) => (
                            <MenuItem key={name} value={name}>
                              {name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </Grid>

                  <ReactECharts
                    //   onEvents={{
                    //     click: handleBarClick,
                    //   }}
                    option={barOption}
                    style={{ height: 250 }}
                    //   key={chartKey}
                  />
                </Paper>
              </Grid>
              <Grid size={{ lg: 4, xs: 12, md: 12, sm: 12 }}>
                <Paper sx={{ padding: 2, boxShadow: "none" }}>
                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      //alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 550,
                        fontSize: "18px",
                        mb: 1,
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      Tolerance Compliance Table {selectCat} - ({selectName})
                    </Typography>

                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        textAlign: "right",
                        mb: -3,
                        mr: 1,
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      {/* {dayjs(startDate).format("DD-MMM-YYYY")} to{" "}
                      {dayjs(endDate).format("DD-MMM-YYYY")} */}
                    </Typography>
                  </Grid>

                  <TableContainer>
                    <Table>
                      {/* TABLE HEADER */}
                      <TableHead>
                        <TableRow>
                          {["Description", "Batch Count", "Percentage"].map(
                            (head) => (
                              <TableCell
                                key={head}
                                sx={{
                                  fontFamily: "Poppins, sans-serif",
                                  fontWeight: 600,
                                  fontSize: "0.9rem",
                                }}
                              >
                                {head}
                              </TableCell>
                            ),
                          )}
                        </TableRow>
                      </TableHead>

                      {/* TABLE BODY */}
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontFamily: "Poppins, sans-serif" }}>
                            With Tolerance
                          </TableCell>
                          <TableCell sx={{ fontFamily: "Poppins, sans-serif" }}>
                            {
                              consuptionDataTable[categoryIndex]?.data?.find(
                                (m) => m.name === selectName,
                              )?.wit
                            }
                          </TableCell>
                          <TableCell sx={{ fontFamily: "Poppins, sans-serif" }}>
                            {
                              consuptionDataTable[categoryIndex]?.data?.find(
                                (m) => m.name === selectName,
                              )?.wit_p
                            }{" "}
                            %
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontFamily: "Poppins, sans-serif" }}>
                            Out of Tolerance
                          </TableCell>
                          <TableCell sx={{ fontFamily: "Poppins, sans-serif" }}>
                            {
                              consuptionDataTable[categoryIndex]?.data?.find(
                                (m) => m.name === selectName,
                              )?.wot
                            }
                          </TableCell>
                          <TableCell sx={{ fontFamily: "Poppins, sans-serif" }}>
                            {
                              consuptionDataTable[categoryIndex]?.data?.find(
                                (m) => m.name === selectName,
                              )?.wot_p
                            }
                            %
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
              <Grid size={{ lg: 8, xs: 12, md: 12, sm: 12 }}>
                <Paper sx={{ padding: 2, boxShadow: "none" }}>
                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      //alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 550,
                        fontSize: "18px",
                        mb: 1,
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      Production and {selectCat} - ({selectName}) Efficiency
                      Report
                    </Typography>

                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        textAlign: "right",
                        mb: -3,
                        mr: 1,
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      {/* {dayjs(startDate).format("DD-MMM-YYYY")} to{" "}
                      {dayjs(endDate).format("DD-MMM-YYYY")} */}
                    </Typography>
                  </Grid>

                  <TableContainer>
                    <Table>
                      {/* TABLE HEADER */}
                      <TableHead>
                        <TableRow>
                          {[
                            "Name",
                            "Date",
                            "Total Batches",
                            "% Within Tolerance",
                            "Loss (kg)",
                            "Saving (kg)",
                            "Net Loss (kg)",
                            // "Cost Impact (₹)",
                          ].map((head) => (
                            <TableCell
                              key={head}
                              sx={{
                                fontFamily: "Poppins, sans-serif",
                                fontWeight: 600,
                                fontSize: "14px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {head}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      {/* TABLE BODY */}

                      <TableBody>
                        {materialArr
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage,
                          )
                          .map((item, i) => (
                            <TableRow key={i}>
                              <TableCell sx={cellStyle}>{selectName}</TableCell>
                              <TableCell sx={cellStyle}>{item.d}</TableCell>
                              <TableCell sx={cellStyle}>{item.bc}</TableCell>
                              <TableCell sx={cellStyle}>{item.p}</TableCell>
                              <TableCell sx={cellStyle}>{item.l}</TableCell>
                              <TableCell sx={cellStyle}>{item.s}</TableCell>
                              <TableCell sx={cellStyle}>{item.n}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      component='div'
                      count={materialArr.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80vh",
            }}
          >
            <Typography
              sx={{
                fontWeight: 650,
                fontSize: "18px",
                mb: 1,
                fontFamily: "Poppins, sans-serif",
              }}
            >
              No data found in the selected category.
            </Typography>
          </Grid>
        )}
      </Navbar1>
    </div>
  );
}
